import { defineStore } from "pinia";
import type { AuthStore } from "~/types/authStore";

const defaultUser = {
  id: '',
  display_name: '',
  role: '',
  wishlist_sharekey: '',
  phone: '',
  crm_data: {},
};
interface InsiderSdkData {
  uuid: string;
  gender: 'M' | 'F';
  birthday: string; // YYYY-MM-DD format
  gdpr_optin: boolean;
  name: string;
  surname: string;
  username: string;
  age: number;
  email: string;
  email_optin: boolean;
  phone_number: string;
  sms_optin: boolean;
  whatsapp_optin: boolean;
  language: string;
  city: string;
  country: string;
  custom: {
    user_lifetime: number;
    membership_type: string;
    [key: string]: any; // Allow additional custom fields
  };
};

export const useUserStore = defineStore("user", {
  state: () => ({
    isLogin: false,
    user: defaultUser,
    isLoginTab: false,
    csrf: '',
    csrf_server: '',
    billings: defaultUser,
    shipping: defaultUser,
    socialRequired: false,
    dataInsiderSdk: null as InsiderSdkData | null
  }),
  actions: {
    set(data: AuthStore) {
      this.isLogin = data.isAuthenticated;

      if( data.isAuthenticated ) {
        this.user = data.user;
        if (data.insiderSdkInfo) {
          this.dataInsiderSdk = data.insiderSdkInfo;
        }
      }

      if( data.loginTab ) {
        this.isLoginTab = true;
      }

      if( data.csrf ) {
        this.csrf = data.csrf;
      }

      if( data.csrf_server ) {
        this.csrf_server = data.csrf_server;
      }
    },
    setInsiderSdkInfo(data: InsiderSdkData) {
      this.dataInsiderSdk = data;
    },

    setCsrf(token: string) {
      this.csrf = token;
    },

    setSocialRequired(socialRequired: boolean) {
      this.socialRequired = socialRequired;
    },
    setInsiderData(data: InsiderSdkData | null) {
      if (data) {
        this.dataInsiderSdk = data;
        console.log('Insider SDK data set successfully');
      } else {
        console.warn('Invalid Insider SDK data provided');
      }
    },

    logout() {
      this.isLogin = false;
      this.user = defaultUser;

      return true;
    },
  },
});
